import {mapView, mapViewCenter, mapViewExtent} from '@mapsight/ui/config';

export default mapView(
	mapViewCenter(1085051, 6867286),
	mapViewExtent(231663, 5671953, 2083274, 7760824), // minx, miny, maxx, maxy
	12 // z
);
